import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Rx';
export class Utils {
    static _uniqueNumber = 1;

    static nextUID = (): string => (Utils._uniqueNumber++).toString();
/**
 * Creates a unique id for submit form.
 * 
 * \@static
 * \@memberOf utils
 * @return {?} 
 * 
 */
static uniqueID () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            let /** @type {?} */ r = Math.random() * 16 | 0, /** @type {?} */ v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
/**
 * Validate input and returns true if input is an element
 * 
 * \@static 
 * 
 * \@memberOf FileManager
 * @param {?} _input
 * @return {?}
 */
static isElement (_input: any) {
        return !!( _input &&
        ( _input.nodeName || // we are a direct element
        (_input.prop && _input.attr && _input.find) ) ); // We have an on and find methode part of jQuery API
    }
/**
 * Validate input and returns true if input is a string
 * 
 * \@static 
 * 
 * \@memberOf Utils
 * @param {?} _input
 * @return {?}
 */
static isString (_input: any) {
        return !!(typeof _input === 'string');
    }
/**
 * @param {...?} args
 * @return {?}
 */
static extendValue (...args: any[]) {
        let /** @type {?} */ _value: any = args[0];
        for (let /** @type {?} */ i = 1; i < args.length; i++) {
            if (typeof args[i] !== 'undefined') {
                _value = args[i];
            }
        }
        return _value;
    }
/**
 * @param {?} subject
 * @return {?}
 */
static asObservable (subject: BehaviorSubject<any>) {
        return new Observable((fn: any) => subject.subscribe(fn));
    }
}

function Utils_tsickle_Closure_declarations() {
/** @type {?} */
Utils._uniqueNumber;
/** @type {?} */
Utils.nextUID;
}

